import React, { use, useContext, useEffect, useState } from "react";
import { DataContext } from "../../../Context/DataContext";
import { ReactComponent as MORE } from "../../../assets/icons/More.svg";
import { ReactComponent as MORESELECTED } from "../../../assets/icons/More-selected.svg";
import { ReactComponent as ADDRESS } from "../../../assets/icons/Address.svg";
import { FormTextInput } from "../../../Components/FormTextInput";
import NewButton from "../../../NewComponents/NewButton";
import { NotificationContext } from "../../../Context/NotificationContext";

import { v4 as uuidv4 } from 'uuid';
import PopUpModal from "../../../NewComponents/PopUpModal";
import { Country, State, City } from "country-state-city";
import SelectSearch from "../../../NewComponents/select-search";
import { firestore } from "../../../firebase.config";
import { AccountType } from "../../../utility/enums";

const ShippingAddresses = ({ windowSize }) => {
  const { userData, teamData } = useContext(DataContext);
  const { showNotification } = useContext(NotificationContext);
  const [editAddressIconSelected, setEditAddressIconSelected] = useState('');
  const [editAddress, setEditAddress] = useState("");
  const [selectedMyAddress, setSelectedMyAddress] = useState('');
  const [deleteModalAddress, setDeleteModalAddress] = useState(null);

  const [editFirstName, setEditFirstName] = useState('');
  const [editLastName, setEditLastName] = useState('');
  const [editCountry, setEditCountry] = useState();
  const [editState, setEditState] = useState('');
  const [editCity, setEditCity] = useState('');
  const [editZipCode, setEditZipCode] = useState('');
  const [editStreet, setEditStreet] = useState('');
  const [editApartment, setEditApartment] = useState('');
  const [editAddressName, setEditAddressName] = useState('');
  const [saveEditsBtnText, setSaveEditsBtnText] = useState('Save');
  const [deleteBtnText, setDeleteBtnText] = useState('Delete Address');

  const [activeDropdown, setActiveDropdown] = useState(null);

  const getFullAddress = (address) => {

    const first = address.firstName ? address.firstName : address.recipient;
    const last = address.firstName && address.lastName ? " " + address.lastName : "";

    const name = first + last;

    return name + ", " + address.country + ", " + address.region + ", " + address.city + ", " + address.zipCode + ", " + address.street + ", " + address.apartment;

  }

  useEffect(() => {
    if(userData && userData.teamId && teamData && teamData.shipping && teamData.shipping.length > 0){
      if(teamData.shipping.length > 0){
      const selected = teamData.shipping.find(a => a.default === true);
      selected && selected.id && setSelectedMyAddress(selected.id);
      return;
      }
    }

    if(!teamData && userData && userData.shipping && userData.shipping.length > 0){
      const selected = userData.shipping.find(a => a.default === true);
      selected && selected.id && setSelectedMyAddress(selected.id);
      return;
    }

  }, [userData, teamData]);

  const handleEditAddress = (address) => {
    setSelectedMyAddress(address === "new" ? "new" : address.id);
    setEditAddress(address === "new" ? "new" : address.id);
    setEditAddressIconSelected("");

    setEditAddressName(address.addressName ? address.addressName : address.recipient || "");
    setEditCountry({ label: address.country, value: address.countryIsoCode } || "");
    setEditFirstName(address.firstName ? address.firstName : address.recipient || "");
    setEditLastName(address.lastName ? address.lastName : "");
    setEditState(address.region || "");
    setEditCity(address.city || "");
    setEditZipCode(address.zipCode || "");
    setEditStreet(address.street || "");
    setEditApartment(address.apartment || "");
  }

  const handleDeleteAddress = (address, isTeamAddress = true, notify = true) => {
    setDeleteBtnText("Deleting...");
    const newAddresses = isTeamAddress ? teamData && teamData.shipping.length > 0 ? teamData.shipping.filter(a => a.id !== address.id) : []
    : userData.shipping && userData.shipping.length > 0 ? userData.shipping.filter(a => a.id !== address.id) : [];

    setEditAddressIconSelected("");
    setEditAddress("");

    firestore.collection(isTeamAddress ? "teams":"users").doc(isTeamAddress ? userData.teamId : userData.id).update({
      shipping: newAddresses
    }).then(() => {
      setDeleteModalAddress(null);
      notify && showNotification('Success', "Address deleted successfully.", 'success');
    }).catch(() => {
      showNotification('Error', "An error ocurred while processing the request. Please, try again. If it persists, contact support.", 'error');
    }).finally(() => {
      setDeleteBtnText("Delete Address");
    })

  }

  const handleUpdateAddress = (address, isTeamAddress = true, movingFromUser = false) => {
    setSaveEditsBtnText("Saving...");

    const newEditedAddress = movingFromUser ? address : {
      addressName: editAddressName,
      firstName: editFirstName,
      lastName: editLastName,
      recipient: editFirstName + " " + editLastName,
      country: editCountry.label,
      countryIsoCode: editCountry.value,
      city: editCity,

      region: editState,

      zipCode: editZipCode,
      street: editStreet,
      apartment: editApartment || "",
      id: address.id || uuidv4(),
      default: address.default || false
    }

    let newAddresses = [];


    if (address === "new" || movingFromUser) {
      if(isTeamAddress && teamData && teamData.shipping && teamData.shipping.length > 0){
        const teamAddresses = movingFromUser ? teamData.shipping.map(a => ({...a, default: false})) : teamData.shipping;
        newAddresses = [...teamAddresses, newEditedAddress];
      }else if(!movingFromUser && !teamData && userData.shipping && userData.shipping.length > 0){
      newAddresses = [...userData.shipping, newEditedAddress];
      }else{
        newAddresses = [newEditedAddress];
      }
    } else {
      newAddresses = isTeamAddress ? teamData.shipping.length > 0 ? teamData.shipping.map(a => a.id === address.id ? newEditedAddress : a) : [] : 
      userData.shipping.length > 0 ? userData.shipping.map(a => a.id === address.id ? newEditedAddress : a) : [];
    }

    firestore.collection((isTeamAddress && address=== "new") || isTeamAddress ? "teams" :"users")
    .doc((isTeamAddress && address=== "new") || isTeamAddress ? userData.teamId : userData.id).update({
      shipping: newAddresses
    }).then(() => {
      setSelectedMyAddress("");
      setEditAddressIconSelected("");
      setEditAddress("");
      setSaveEditsBtnText("Save");
      showNotification('Success', "Address updated successfully.", 'success');
    }).catch(() => {
      setSaveEditsBtnText("Save");
      showNotification('Error', "An error ocurred while processing the request. Please, try again. If it persists, contact support.", 'error');
    })

  }

  const handleOnSelectAddress = (address, isTeamAddress = true, moveToTeam = false) => {
    setSelectedMyAddress(address.id);
    setEditAddressIconSelected("");
    setEditAddress("");

    if(!isTeamAddress && userData.teamId && teamData){
      // move address to team and delete from user account
      handleUpdateAddress(address, true, true);
      handleDeleteAddress(address, false, false);
      return;
    }

    const newAddresses = isTeamAddress ? teamData.shipping && teamData.shipping.length > 0 ? teamData.shipping.map(a => a.id === address.id ? { ...a, default: true } : { ...a, default: false }) : []
    : userData.shipping && userData.shipping.length > 0 ? userData.shipping.map(a => a.id === address.id ? { ...a, default: true } : { ...a, default: false }) : [];

    firestore.collection(isTeamAddress ? "teams" :"users").doc(isTeamAddress ? userData.teamId : userData.id).update({
      shipping: newAddresses
    }).then(() => {
      setSaveEditsBtnText("Save");
      showNotification('Success', "Address updated as default address.", 'success');
    }).catch(() => {
      setSaveEditsBtnText("Save");
      showNotification('Error', "An error ocurred while processing the request. Please, try again. If it persists, contact support.", 'error');
    })

  }

  const countries = Country.getAllCountries().map((country) => ({
    label: country.name,
    value: country.isoCode
  }));

  const states = editCountry
    ? State.getStatesOfCountry(editCountry.value).map(state => ({
      label: state.name,
      value: state.isoCode
    }))
    : [];

  const cities = editState
    ? City.getCitiesOfState(editCountry.value, editState.value).map(city => ({
      label: city.name,
      value: city.name
    }))
    : [];

  const handleOpenMenu = (i) => {
    setEditAddressIconSelected(i);
  }


  return <>
    {deleteModalAddress && <PopUpModal title={"Delete Address"} backBtnText="Back to Shipping Addresses" subText="Are you sure you want to delete this address?" text={deleteModalAddress.addressName} btnText={deleteBtnText}
      iconBgColor="#FFF6EA" deleteBtn={true} showClose onClose={() => setDeleteModalAddress(null)} onClick={() => { handleDeleteAddress(deleteModalAddress, userData.teamId ? true : false) }} onBackClick={() => setDeleteModalAddress(null)} disableBtn={deleteBtnText === "Deleting..."}>
      <ADDRESS />
    </PopUpModal>}
    <div className="accountSettingShippingWrap">
      {userData && userData.teamId && teamData && teamData.shipping && teamData.shipping.length > 0 && teamData.shipping.map((address, i) => (
        <div key={address.id} className="hardCopyAddressContainer"
          style={{ borderColor: selectedMyAddress === address.id ? '#12ABBF' : '#E6E7E9' }}>
          <div className="quoteOptionalTitleRow">
            <div className="hardCopyAddressDetails" onClick={() => { }}>
              <h6 className="hardCopyAddressTitle">{address.addressName ? address.addressName : address.recipient} <span>{address.default && "(primary)"}</span></h6>
              <p className="hardCopyAddressText">{getFullAddress(address)}</p>
            </div>
            {(userData.teamRole === AccountType.OWNER ||
                userData.teamRole === "admin") && <div className="hardCopyAddressIconWrap"
              tabIndex={0} // Enables blur event for accessibility
              onBlur={() => setEditAddressIconSelected("")}>
            {editAddressIconSelected === address.id ? <MORESELECTED className="hardCopyAddressIcon" onClick={(e) => {
                e.stopPropagation(); // Prevents event bubbling
                setEditAddressIconSelected("")
              }} /> :
              <MORE className="hardCopyAddressIcon" onClick={(e) => {
                e.stopPropagation(); // Prevents event bubbling
                setEditAddressIconSelected(address.id);
              }} />}
            {editAddressIconSelected === address.id &&  <div className="hardCopyAddressEditWrap">
              <div className="hardCopyAddressEdit" onClick={() => { handleEditAddress(address) }}>Edit</div>
              {!address.default && <div className="hardCopyAddressEdit" onClick={() => handleOnSelectAddress(address, true)}>Set as Primary</div>}
              <div className="hardCopyAddressEdit" onClick={() => { setDeleteModalAddress(address); setEditAddress(""); setEditAddressIconSelected("") }}>Delete Address</div>
            </div>}
          </div>}
        </div>

          { editAddress === address.id && <div className="editInputsContainer">

          <div className="quoteDetailsInputsContainer">
            <FormTextInput placeholder={"Address Name (e.g, Office)"} value={editAddressName} onChange={setEditAddressName} />
          </div>
          <div className="quoteDetailsInputsContainer">
            <SelectSearch
              placeholder="Select Country"
              value={editCountry.value}
              setValue={(val) => setEditCountry(countries.find(c => c.value === val))}
              list={countries}
              activeDropdown={activeDropdown}
              setActiveDropdown={setActiveDropdown}
              dropdownId="country"
            />
          </div>
          <div className="quoteDetailsInputsContainer">
            <FormTextInput placeholder={"First Name"} value={editFirstName} onChange={setEditFirstName} />
            <FormTextInput placeholder={"Last Name"} value={editLastName} onChange={setEditLastName} />
          </div>
          <div className="quoteDetailsInputsContainer">
            <SelectSearch
              placeholder="Select State"
              value={editState ? editState.value : ""}
              setValue={(val) => setEditState(states.find(s => s.value === val))}
              list={states}
              activeDropdown={activeDropdown}
              setActiveDropdown={setActiveDropdown}
              dropdownId="state"
              disabled={!editCountry.value}
            />
            <SelectSearch
              placeholder="Select City"
              value={editCity ? editCity.value : ""}
              setValue={(val) => setEditCity(cities.find(c => c.value === val))}
              list={cities}
              activeDropdown={activeDropdown}
              setActiveDropdown={setActiveDropdown}
              dropdownId="city"
              disabled={!editCountry.value || !editState.value}
            />
            <FormTextInput placeholder={"ZIP code"} value={editZipCode} onChange={setEditZipCode} />
          </div>
          <div className="quoteDetailsInputsContainer">
            <FormTextInput placeholder={"Street/Address"} value={editStreet} onChange={setEditStreet} />
          </div>
          <div className="quoteDetailsInputsContainer">
            <FormTextInput placeholder={"Apartment, suite, etc."} value={editApartment} onChange={setEditApartment} />
          </div>
          <div className="editInputBtnContainer">
            <NewButton onClick={() => handleUpdateAddress(address,true)} disabled={saveEditsBtnText === "Saving..." || ((editAddressName === "" || editFirstName === "" || editCountry === "" || editCity === "" ||
              editState === "" || editZipCode === "" || editStreet === ""))} text={saveEditsBtnText} width="150px" smallPadding={true} />
            <NewButton onClick={() => { setEditAddress(""); setSelectedMyAddress("") }} text={"Cancel"} icon={false} whiteBtn back={true} width="150px" smallPadding={true} />
          </div>
        </div>}
    </div>
      ))}
      {userData && userData.shipping && userData.shipping.length > 0 && userData.shipping.map((address, i) => (
        <div key={address.id} className="hardCopyAddressContainer"
          style={{ borderColor: selectedMyAddress === address.id ? '#12ABBF' : '#E6E7E9' }}>
          <div className="quoteOptionalTitleRow">
            <div className="hardCopyAddressDetails" onClick={() => { }}>
              <h6 className="hardCopyAddressTitle">{address.addressName ? address.addressName : address.recipient} <span>{!userData.teamId && address.default ? "(primary)" : ""}</span></h6>
              <p className="hardCopyAddressText">{getFullAddress(address)}</p>
            </div>
            <div className="hardCopyAddressIconWrap" 
              tabIndex={0} // Enables blur event for accessibility
              onBlur={() => setEditAddressIconSelected("")}>
            {editAddressIconSelected === address.id ? <MORESELECTED className="hardCopyAddressIcon" onClick={(e) => {
                e.stopPropagation(); // Prevents event bubbling
                setEditAddressIconSelected("")
              }} /> :
              <MORE className="hardCopyAddressIcon" onClick={(e) => {
                e.stopPropagation(); // Prevents event bubbling
                setEditAddressIconSelected(address.id);
              }} />}
            {editAddressIconSelected === address.id &&  <div className="hardCopyAddressEditWrap">
              <div className="hardCopyAddressEdit" onClick={() => { handleEditAddress(address) }}>Edit</div>
              {userData.teamId && (!address.default) && <div className="hardCopyAddressEdit" onClick={() => handleOnSelectAddress(address, false, true)}>Move to Team</div>}
              <div className="hardCopyAddressEdit" onClick={() => { setDeleteModalAddress(address); setEditAddress(""); setEditAddressIconSelected("") }}>Delete Address</div>
            </div>}
          </div>
        </div>

          {editAddress === address.id && <div className="editInputsContainer">

          <div className="quoteDetailsInputsContainer">
            <FormTextInput placeholder={"Address Name (e.g, Office)"} value={editAddressName} onChange={setEditAddressName} />
          </div>
          <div className="quoteDetailsInputsContainer">
            <SelectSearch
              placeholder="Select Country"
              value={editCountry.value}
              setValue={(val) => setEditCountry(countries.find(c => c.value === val))}
              list={countries}
              activeDropdown={activeDropdown}
              setActiveDropdown={setActiveDropdown}
              dropdownId="country"
            />
          </div>
          <div className="quoteDetailsInputsContainer">
            <FormTextInput placeholder={"First Name"} value={editFirstName} onChange={setEditFirstName} />
            <FormTextInput placeholder={"Last Name"} value={editLastName} onChange={setEditLastName} />
          </div>
          <div className="quoteDetailsInputsContainer">
            <SelectSearch
              placeholder="Select State"
              value={editState ? editState.value : ""}
              setValue={(val) => setEditState(states.find(s => s.value === val))}
              list={states}
              activeDropdown={activeDropdown}
              setActiveDropdown={setActiveDropdown}
              dropdownId="state"
              disabled={!editCountry.value}
            />
            <SelectSearch
              placeholder="Select City"
              value={editCity ? editCity.value : ""}
              setValue={(val) => setEditCity(cities.find(c => c.value === val))}
              list={cities}
              activeDropdown={activeDropdown}
              setActiveDropdown={setActiveDropdown}
              dropdownId="city"
              disabled={!editCountry.value || !editState.value}
            />
            <FormTextInput placeholder={"ZIP code"} value={editZipCode} onChange={setEditZipCode} />
          </div>
          <div className="quoteDetailsInputsContainer">
            <FormTextInput placeholder={"Street/Address"} value={editStreet} onChange={setEditStreet} />
          </div>
          <div className="quoteDetailsInputsContainer">
            <FormTextInput placeholder={"Apartment, suite, etc."} value={editApartment} onChange={setEditApartment} />
          </div>
          <div className="editInputBtnContainer">
            <NewButton onClick={() => handleUpdateAddress(address, false)} disabled={saveEditsBtnText === "Saving..." || ((editAddressName === "" || editFirstName === "" || editCountry === "" || editCity === "" ||
              editState === "" || editZipCode === "" || editStreet === ""))} text={saveEditsBtnText} width="150px" smallPadding={true} />
            <NewButton onClick={() => { setEditAddress(""); setSelectedMyAddress("") }} text={"Cancel"} icon={false} whiteBtn back={true} width="150px" smallPadding={true} />
          </div>
        </div>}
    </div>
      ))}


      <div className="hardCopyAddressContainer"
        style={{ borderColor: editAddress === "new" ? '#12ABBF' : '#E6E7E9' }}>
        <div className="quoteOptionalTitleRow">
          <div className="hardCopyAddressDetails" onClick={() => { handleEditAddress("new"); setSelectedMyAddress("") }}>
            <h6 className="hardCopyAddressTitle" style={{ marginTop: "2px" }}>Add New Address</h6>
          </div>
        </div>

        {editAddress === "new" && <div className="editInputsContainer">

          <div className="quoteDetailsInputsContainer">
            <FormTextInput placeholder={"Address Name (e.g. Office) "} value={editAddressName} onChange={setEditAddressName} />
          </div>
          <div className="quoteDetailsInputsContainer">
            <SelectSearch
              placeholder="Select Country"
              value={editCountry.value}
              setValue={(val) => setEditCountry(countries.find(c => c.value === val))}
              list={countries}
              activeDropdown={activeDropdown}
              setActiveDropdown={setActiveDropdown}
              dropdownId="country"
            />
          </div>
          <div className="quoteDetailsInputsContainer">
            <FormTextInput placeholder={"First Name"} value={editFirstName} onChange={setEditFirstName} />
            <FormTextInput placeholder={"Last Name"} value={editLastName} onChange={setEditLastName} />
          </div>
          <div className="grid md:grid-cols-3 sm:grid-cols-2 items-center md:gap-3 gap-2 w-full">
            <div className="sm:col-span-1 col-span-2">
              <FormTextInput
                placeholder="Select State"
                value={editState}
                onChange={setEditState}
              />
            </div>

            <div className="sm:col-span-1 col-span-2">
              <FormTextInput
                placeholder="Select City"
                value={editCity}
                onChange={setEditCity}
              />
            </div>

          <div className="md:col-span-1 col-span-2">
            <FormTextInput placeholder={"ZIP code"} value={editZipCode} onChange={setEditZipCode} />
          </div>
        </div>
        <div className="quoteDetailsInputsContainer">
          <FormTextInput placeholder={"Street/Address"} value={editStreet} onChange={setEditStreet} />
        </div>
        <div className="quoteDetailsInputsContainer">
          <FormTextInput placeholder={"Apartment, suite, etc."} value={editApartment} onChange={setEditApartment} />
        </div>
        <div className="w-full sm:flex grid sm:grid-cols-2 grid-cols-1 gap-4">
          <NewButton onClick={() => handleUpdateAddress("new", userData.teamId ? true : false)} disabled={saveEditsBtnText === "Saving..." || (editAddressName === "" || editFirstName === "" || editCountry === "" || editCity === "" ||
            editState === "" || editZipCode === "" || editStreet === "")} text={saveEditsBtnText} width={windowSize.width < 640 ? "100%" : "150px"} smallPadding={true} />
          <NewButton onClick={() => setEditAddress("")} text={"Cancel"} icon={false} whiteBtn back={true} width={windowSize.width < 640 ? "100%" : "150px"} smallPadding={true} />
        </div>
      </div>}
    </div>

    </div >
  </>;
};

export default ShippingAddresses;
